import { DataGridService } from './../../../../_template/_components/query/data-grid/data-grid.service';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from '../../../../_config/config';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RadialBarService {
  gateway = this.config.gateway;
  url= `${this.gateway.url}/lbw`;
  constructor(
    private config: CONFIG,
    private http: HttpClient,
    private dataGridService: DataGridService
    ) { }

    onGetDataGraphic(queryId, basedOnId, args, queryConfigType) {
      //  Peticion para posteriormente visualizar la grafica
      return this.dataGridService.onGetDataGrid(queryId, basedOnId, args, queryConfigType, "", "", 0, 50);
      //return this.http.post(`${this.url}/query/getDataGraphic`, object);
    }
}
